export function farloUiRevolverCarousel(element) {
    // 1) Init Flickity
    let flkty;
    if(element.classList.contains('alignfull')){
        const flkty = new Flickity(element, {
            cellAlign:    'center',
            pageDots:     true,
            prevNextButtons: true,
            wrapAround:   true,
            groupCells:   true,
            freeScroll:   true,
            scrollSnap: false,
            draggable:    true,
            dragThreshold: 1,
            autoPlay:     6000,
            adaptiveHeight: true
          });
              // 2) Once all images in the carousel are fully loaded, force a resize
    imagesLoaded(element, () => {
        flkty.resize();
      });
    
      // 3) (Optional) also resize again on window load in case some assets load late
      window.addEventListener('load', () => flkty.resize());
    } else {
        const flkty = new Flickity(element, {
            cellAlign:    'center',
            pageDots:     true,
            prevNextButtons: true,
            wrapAround:   true,
            groupCells:   true,
            freeScroll:   false,
            scrollSnap: true,
            draggable:    true,
            dragThreshold: 1,
            autoPlay:     6000,
            adaptiveHeight: true
          });
              // 2) Once all images in the carousel are fully loaded, force a resize
    imagesLoaded(element, () => {
        flkty.resize();
      });
    
      // 3) (Optional) also resize again on window load in case some assets load late
      window.addEventListener('load', () => flkty.resize());
    }
  

  }
  